module.exports = __webpack_public_path__ + "img/eos.b9be8c85.svg";